<template>


  <t-dialog-form :generalErrors="generalErrors" :title="modelActivity.name"
                 :ok-text="onlyView ? 'Fechar' : 'Salvar ' + modelActivity.name"
                 :status="status"
                 @hidden="closeDialog" large
                 :command="onlyView ? 'view' : 'update'"
                 :id="id"
                 ref="dialog_form" @onSubmit="onSubmit">


    <template #add-buttons>
      <t-button v-if="pageFormIsLoaded && form.modelActivity.enableCopyLastActivity"
                @click="confirmCopyLastActivity()">Copiar última atividade
      </t-button>
    </template>


    <template #default>

      <b-card class="border">

        <t-msg info v-if="pageFormIsLoaded && modelActivity.note !== ''">{{ modelActivity.note }}</t-msg>

        <b-card-title>DADOS BÁSICOS</b-card-title>

        <!--ATENÇÃO NÃO ESQUECER DE UTILIZAR template #default="{status} para funcionamento correto-->
        <t-page-form-field-customized
            ref="fieldsGeneral"
            :command="command" :status="status" :user-auth="userAuth"
            :fields-customizable="entityFieldCustomized('page')"
            :primary-key="form['activity'+modelActivity.typeActivityNumber+'Id']" :foreign-key="currentPage.pageId"
            :busy="!pageFormIsLoaded"
            :primary-key-column="fieldKey" foreign-key-column="pageId"
        />

        <t-input v-model="form.note" label="Observações Gerais" max-length="500" textarea/>


      </b-card>

    </template>

    <template #out-of-form>

      <b-card class="border mt-2" v-if="modelActivity.enableChild && pageFormIsLoaded">

        <b-card-title>{{ form.typeActivity.titleChild }}</b-card-title>

        <ChecklistActivityFormChildEmbeddable
            :activity-number="modelActivity.typeActivityNumber"
            :foreign-key="form['activity'+ modelActivity.typeActivityNumber + 'Id']"
            :checklist-id="form.checklistId"/>


      </b-card>

    </template>


  </t-dialog-form>


</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageFormMixin from "@/mixins/page/pageFormMixin";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import ChecklistActivityFormChildEmbeddable
  from "@/views/modules/checklist/ChecklistActivity/embeddable/ChecklistActivityFormChildEmbeddable";
import ui from "@/assets/scripts/ui";
import ChecklistModelActivityService from "@/services/modules/checklist/ChecklistModelActivity.service";


export default {
  name: 'ChecklistModelActivityDialog',
  components: {tDialogForm, ChecklistActivityFormChildEmbeddable},
  mixins: [pageDefaultMixin, pageFormMixin],
  data() {
    return {
      id: "modal-checklist-activity-form-detail",
      pageIsLoaded: false,
      path: "checklist/activity" + this.modelActivity.typeActivityNumber, //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      fieldKey: "activity" + this.modelActivity.typeActivityNumber + "Id",
      form: {},
    }
  },
  props: {
    show: Boolean,
    onlyView: Boolean,
    modelActivity: Object,
  },

  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      await crudGeneral.getById(this.path, this.modelActivity.activityNumber).then(
          async response => {

            this.form = response.data

            if (this.fieldsCustomizable.length > 0) {

              for (const entity of this.fieldsCustomizable) {
                await this.getFieldsCustomizable(entity.entity)
              }

            }
          }
      ).catch(error => this.responseError(error))

      this.pageIsLoaded = true
      this.pageFormIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    confirmCopyLastActivity() {

      ui.msgConfirm(this, 'Atenção', 'Deseja realizar a cópia dos dados da última atividade preenchida para o mesmo local?<br /><br />Atenção caso o sistema encontrar, irá sobrepor as informações atuais.', async () => {

        this.pageIsLoaded = false
        this.pageFormIsLoaded = false

        await ChecklistModelActivityService.copyData(this.form.checklistActivityId).then(async() => {

          ui.toast(this,'Informação','Copia dos dados da última atividade realizada com sucesso!')

          await this.mountedContinued()


        }).catch(error => this.responseError(error))

      })

    },


    closeDialog() {
      this.$emit("onClose")
    },

    async onSubmitContinued() {

      this.command = 'update'
      this.status = "sending"

      await this.setSending(
          this.form[this.fieldKey],
          () => {
            this.$bvModal.hide(this.id)
            this.$emit("onSubmit", this.form) //Envia o proprio formulário pois é mais completo
          },
      )


    },

    async onSubmit() {

      if (this.onlyView) {
        this.$emit("onClose")
      } else {

        this.status = "sending"

        //Verifica se alguma regra será aplicada
        await this.injectFieldsForm()
        await this.onSubmitContinued()


      }


    },

    //--------------------------------------------------------------------------------------
  },


  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault(false, false)

    await this.mountedContinued()

  },

}
</script>